import { render, staticRenderFns } from "./ClientsCreateDialog.vue?vue&type=template&id=7c478f81&scoped=true&"
import script from "./ClientsCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./ClientsCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsCreateDialog.vue?vue&type=style&index=0&id=7c478f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c478f81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCheckbox,VCol,VContainer,VForm,VRow,VSelect,VTextField})
